import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { AuthService } from '../../../../shared/libs/auth/auth.service';
import { Router } from '@angular/router';
import { CompanyFilterItem, CompanyFilterService } from 'src/app/services/filters/company-filter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Selectable } from 'src/app/shared/types/selectable.type';

@Component({
	standalone: false,
	selector: 'bt-company-selection',
	templateUrl: './company-selection.component.html',
	styleUrls: ['./company-selection.component.scss']
})
export class CompanySelectionComponent implements OnInit {
	readonly #destroyRef = inject(DestroyRef);
	readonly #router = inject(Router);
	readonly #authService = inject(AuthService);
	readonly companyFilterService = inject(CompanyFilterService);

	selectedCompany: Array<Selectable<CompanyFilterItem>> = [];
	datasource: Array<Selectable<CompanyFilterItem>> = [];

	get selectedCompanyName(): string {
		return this.selectedCompany[0]?.displayName ?? 'Select a company';
	}

	ngOnInit(): void {
		this.companyFilterService.search('');
		this.companyFilterService.datasource.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((datasource) => {
			this.datasource = datasource.map((element) => ({
				...element,
				selected: !!this.selectedCompany.find((selected) => selected.displayId === element.displayId)
			}));
		});
	}

	onClickCompany(company: Selectable<CompanyFilterItem>): void {
		this.selectedCompany = [{ ...company, selected: true }];
		this.datasource = this.datasource.map((element) => ({
			...element,
			selected: element.displayId === company.displayId
		}));
	}

	companySelection(): void {
		if (!this.selectedCompany.length) return;

		const companyId = Number(this.selectedCompany[0].displayId);
		this.#authService
			.authentication(this.#router.routerState.snapshot, companyId)
			.pipe(takeUntilDestroyed(this.#destroyRef))
			.subscribe((res: any) => {
				this.#authService.setCompanySelected(companyId);

				if (this.#authService.isCompany()) {
					this.#router.navigate(['/company']);
				} else if (this.#authService.isPhotographer()) {
					this.#router.navigate(['/photographer']);
				}
			});
	}
}
